import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap';
import Radium from 'radium';
import { colors } from 'z-react-components';

import Box from '../Box';
import Header from './Header';
import Subjects from './Subjects';
import Ticker from '../Ticker';
import Video from './Video';
import FullWidthRow from '../FullWidthRow';

const styles = {
    rowStyle: {
        background: colors.grey100,
        paddingBottom: 80
    },
    boxStyle: {
        maxWidth: 1200,
        float: 'none',
        margin: '0 auto',
        textAlign: 'center',
        paddingTop: 25,
        paddingLeft: 0,
        paddingRight: 0
    }
};

class PublicHome extends Component {
    static propTypes = {
        isLoggedIn: PropTypes.bool,
        tickerMessage: PropTypes.string
    };

    render() {
        const { isLoggedIn, tickerMessage } = this.props;
        return (
            <Row style={{ marginLeft: '0px', marginRight: '0px' }}>
                {tickerMessage ? <Ticker isLoggedIn={isLoggedIn} tickerMessage={tickerMessage} /> : null}
                <Header />
                <Subjects />
                <Video />
                <FullWidthRow backgroundColor={colors.grey100} maxContentWidth={1200}>
                    <Row style={styles.rowStyle}>
                        <div style={styles.boxStyle}>
                            <Box
                                btnLabel={'Vai a Esercizi'}
                                description={
                                    'Crea una nuova verifica per la tua classe in pochi e semplici passaggi. Puoi usare esercizi già pronti o crearli tu.'
                                }
                                iconUrl={'./_assets/images/crea_compito.svg'}
                                title={'Esercizi'}
                                url={'/search'}
                            />
                            <Box
                                btnLabel={'Vai a Verifiche'}
                                description={
                                    'Trovi le prove di verifica del tuo libro e tante altre della tua materia, che puoi scegliere e stampare per i tuoi studenti.'
                                }
                                iconUrl={'./_assets/images/verifica_zanichelli.svg'}
                                title={'Verifiche'}
                                url={'/zLibrary'}
                            />
                            <Box
                                btnLabel={'Vai al tuo archivio'}
                                description={'Salva le verifiche e gli esercizi nel tuo archivio, ritrovi tutto per il prossimo anno.'}
                                iconUrl={'./_assets/images/libreria.svg'}
                                title={'Il tuo archivio'}
                                url={'/myLibrary'}
                            />
                        </div>
                    </Row>
                </FullWidthRow>
            </Row>
        );
    }
}

function mapStateToProps({ TickerReducer, auth }) {
    return {
        isLoggedIn: auth.isLoggedIn,
        tickerMessage: TickerReducer.ticker.tickerMessage
    };
}

export default connect(mapStateToProps)(Radium(PublicHome));
